import { TimeRequestDateTimes } from "utils/interfaces"

export function sortDateAndTime<T extends TimeRequestDateTimes>(array: T[]): T[] {
    return array.sort((a, b) => {
        if (a.time && a.date && b.date && b.time) {
            return (
                new Date(`${a.date} ${a.time}`).getTime() -
                new Date(`${b.date} ${b.time}`).getTime()
            )
        }
        return 0
    })
}
